import React from 'react';

const LegacyCategoryIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M9.39996 3H4.39996C3.84768 3 3.39996 3.44772 3.39996 4V11C3.39996 11.5523 3.84768 12 4.39996 12H9.39996C9.95225 12 10.4 11.5523 10.4 11V4C10.4 3.44772 9.95225 3 9.39996 3Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M20.4 3H15.4C14.8477 3 14.4 3.44772 14.4 4V7C14.4 7.55228 14.8477 8 15.4 8H20.4C20.9522 8 21.4 7.55228 21.4 7V4C21.4 3.44772 20.9522 3 20.4 3Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M20.4 12H15.4C14.8477 12 14.4 12.4477 14.4 13V20C14.4 20.5523 14.8477 21 15.4 21H20.4C20.9522 21 21.4 20.5523 21.4 20V13C21.4 12.4477 20.9522 12 20.4 12Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.39996 16H4.39996C3.84768 16 3.39996 16.4477 3.39996 17V20C3.39996 20.5523 3.84768 21 4.39996 21H9.39996C9.95225 21 10.4 20.5523 10.4 20V17C10.4 16.4477 9.95225 16 9.39996 16Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default LegacyCategoryIcon;
